<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<p-toast></p-toast>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Lista de fuentes de emisión</h1>
      <p class="main-subtitle">
        Total de fuentes de emisión: {{ totalRecords }}
      </p>
    </div>
  </div>

  <app-emissions-factors-filter
    (filter)="handleFilter($event)"
    (clear)="handleClearFilters()"
  >
  </app-emissions-factors-filter>

  <app-emissions-sources-list
    [data]="filteredData"
    [isBusinessSelection]="isBusiness"
    [isOfficeSelection]="isOffice"
    [sourcesMap]="sourcesMap"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    [first]="first"
    [rows]="pageSize"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    [isAllSelected]="isAllSelected"
    [isIndeterminate]="isIndeterminate"
    (toggleAll)="handleToggleAll($event)"
    (toggleRow)="handleToggleRow($event)"
    (pageChange)="handlePageChange($event)"
    (toggleSort)="handleToggleSort($event)"
    [selectedSources]="selectedSources"
    (selectionChange)="onSelectionChange($event)"
  />

  @if (unsavedChangesCount > 0) {
  <app-form-footer>
    <div class="flex flex-row justify-between gap-2 w-full">

        <p class="font-bold px-4 py-2">{{ unsavedChangesCount }} cambios sin guardar</p>
      
      <p-button
        fluid
        label="Guardar"
        (onClick)="onSave()"
        class="w-30"
      ></p-button>
    </div>
  </app-form-footer>
  }


</div>
